module.exports = __webpack_public_path__ + "img/2-1.4f8dec77.svg";